import {h, Fragment} from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import useSwipe from "./useSwipe";

function FilterMobile(props) {

  let opts = Object.keys(props.programs.map(c => c[props.target]).reduce((acc, opts) => [
    ...acc,
    ...opts
  ], [])
  .filter(a => a)
  .reduce((acc, opt) => Object.assign(acc, {[opt]: true}), {})).sort();

  const currentFilters = props.filters[props.target] || [];

  const handleOptionClick = (option) => () => {
    const active = currentFilters.indexOf(option) > -1;
    delete props.filters.view; // Always erase view filters whenever an option is clicked.

    if (active) {
      const newFilters = currentFilters.filter(i => i !== option);
      props.setFilters(Object.assign({}, props.filters, {
        [props.target]: newFilters
      }));
    } else {
      const newFilters = [
        ...currentFilters,
        option
      ];
      props.setFilters(Object.assign({}, props.filters, {
        [props.target]: newFilters
      }))
    }
  }


  // Custom sort the items in "Arts Area"
  if(props.target == 'area'){
    const optsOrdered = [];

    opts.forEach( value => {
      let sorted = {
        value: value,
        weight: 100, // Random items get sorted last.
      };
      switch(value){
        case 'Music':
          sorted.weight = 10;
          break;
        case 'Creative Writing':
          sorted.weight = 20;
          break;
        case 'Theatre Arts':
          sorted.weight = 30;
          break;
        case 'Visual Arts':
          sorted.weight = 40;
          break;
        case 'Film and New Media':
          sorted.weight = 50;
          break;
        case 'Dance':
          sorted.weight = 60;
          break;
        case 'College Prep':
          sorted.weight = 70;
          break;
        case 'Interdisciplinary Arts':
          sorted.weight = 80;
          break;
      }
      optsOrdered.push(sorted);
    });

    // Flatten our array of objects back into a plain array.
    opts = optsOrdered.sort((a, b) => a.weight > b.weight).map((el) => el.value);

  }

  if (props.target == 'grade') {
    const optsOrdered = [];

    opts.forEach(value => {
      let sorted = {
        value: value,
        weight: 100, // Random items get sorted last.
      };
      switch (value) {
        case "Adult (Ages 18+)":
          sorted.weight = 10;
          break;
        case "Teens (Grades 6-12)":
          sorted.weight = 20;
          break;
        case "Kids (Grades 2-5)":
          sorted.weight = 30;
          break;
      }
      optsOrdered.push(sorted);
    });

    // Flatten our array of objects back into a plain array.
    opts = optsOrdered.sort((a, b) => a.weight > b.weight).map((el) => el.value);

    if (props.mode === 'certificates') {
      opts = opts.filter(opt => opt !== 'Kids (Grades 2-5)');
    }

  }

  const strToId = (str) => {
    return str.toLowerCase().replace(/\W{1,}/g, '-');
  };

  return (

    <div className="filter__group">
      <p className="filter__title">{Drupal.t(props.title)}</p>
      <div className="filter__content">
        {opts.map(opt => (
          <label for={strToId('input-mobile-' + opt)} className="filter__label" onChange={handleOptionClick(opt)}>
            <input id={strToId('input-mobile-' + opt)} type="checkbox" checked={currentFilters.indexOf(opt) > -1}/>
            <span className="filter__checkbox">{Drupal.t(opt)}</span>
          </label>
        ))}
      </div>
    </div>

  );

}


function MobileView (props) {
  const node = useRef();
  return (
    <div className="view-button-wrapper" ref={node}>
      <button className="filter__title view-button" onClick={props.handleViewButtonClick(props.title, props.target, true)}>
        {Drupal.t(props.title)}
      </button>
    </div>
  );
}


export default function FiltersMobile(props) {
  const [open,
    setOpen] = useState(false);
  const isCertificateMode = props.mode === 'certificates';

  // Keypress hook.
  const useKeyPress = (handlers = {}) => {
    useEffect(() => {
      const onKeyDown = (event) => {
        if (!event.repeat) {
          handlers[event.code]?.();
        }
      };

      document.addEventListener("keydown", onKeyDown);
      return () => document.removeEventListener("keydown", onKeyDown);
    }, [handlers]);
  };

  const swipeHandlers = useSwipe({ onSwipedLeft: () => setOpen(false), onSwipedRight: () => setOpen(false) });

  // Handle keypresses.
  useKeyPress({
    Escape: () => setOpen(false), // Close the mobile sidebar.
  });


  const topClasses = open
    ? "filter filter--mobile active"
    : "filter filter--mobile";

  return <div {...swipeHandlers} className={topClasses}>
    <button
      className="filter__toggle filter__toggle--filter button--green"
      onClick={e => setOpen(!open)}>{Drupal.t("Filter")}</button>
    <div className="filter__flyout">
      <button className="filter__flyout__close" onClick={e => setOpen(!open)}>
        <span className="screen-reader-text">{Drupal.t("Close")}</span>
      </button>
      {!isCertificateMode &&
        <>
          <div class="view-by">
            {Drupal.t("View By")}
          </div>
          <MobileView title={Drupal.t("All")} target="view" type="view" {...props} />
          <MobileView title={Drupal.t("Popular")} target="view" type="view" {...props} />
          <MobileView title={Drupal.t("New")} target="view" type="view" {...props} />
        </>
      }
      <div class="filter-by">
        {Drupal.t("Filter By")}
      </div>
      <FilterMobile title={Drupal.t("Area of Study")} target="area" {...props}/>
      <FilterMobile title={Drupal.t("Age Range")} target="grade" {...props}/>
      {!isCertificateMode &&
        <FilterMobile title={Drupal.t("Program Type")} target="duration" {...props}/>
      }

      <button className="button--green" onClick={e => setOpen(!open)}>{Drupal.t("Apply")}</button>
    </div>
  </div>
}
